import React from "react";
import { inject } from "mobx-react";
import BenefitsContainer from "Containers/BenefitsContainer";
import ProvidersContainer from "./containers/ProvidersContainer";
import { PlansB2BLayout } from "ComponentsUI/PlanB2B";
import BusinessBannerContainer from "Containers/BusinessBannerContainer";
import ReviewsContainer from "./containers/Reviews";
import WithSeoText from "Layouts/WithSeoText";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import { isMainSiteCode } from "Utils/siteConfig";

const nowShowBusinessTariffsRegions = [77, 50, 78, 47];

@inject("ApplicationModel")
export default class Page extends React.Component {
	render() {
		const {
			seoData,
			ApplicationModel: { text },
		} = this.props;
		let currentRegionId = this.props.ApplicationModel.currentRegion.id;
		let dontShowTariffs = !!nowShowBusinessTariffsRegions.find((item) => item === currentRegionId);
		const siteCode = this.props.ApplicationModel.siteCode;

		return (
			<>
				{isMainSiteCode(siteCode) && <div></div>}
				<DeclinationContainerNew>
					<BusinessBannerContainer
						h1Banner={seoData && seoData.h1}
						h1Slider={text.SERVICE_FOR_BUSINESS}
					/>
				</DeclinationContainerNew>
				<WithSeoText seoData={seoData} text={text}>
					<ProvidersContainer />
					{!!dontShowTariffs && <PlansB2BLayout text={text} />}
					<ReviewsContainer />
				</WithSeoText>
			</>
		);
	}
}
